import { Badge } from '@/components/ui/badge'
import { X } from 'lucide-react'
import { useTags } from '../hooks/useTags'

interface TagListProps {
  tags: number[]
  readOnly?: boolean
  onRemove?: (tagId: number) => void
}

export function TagList({ tags, readOnly = false, onRemove }: TagListProps) {
  const { data: allTags } = useTags()

  if (!tags || tags.length === 0) {
    return (
      <div className="text-sm text-muted-foreground">
        No tags selected
      </div>
    )
  }

  return (
    <div className="flex flex-wrap gap-2">
      {tags.map((tagId) => {
        const tag = allTags?.find((t) => t.id === tagId)
        if (!tag) return null

        return (
          <Badge key={tagId} variant="secondary" className="text-sm">
            {tag.name}
            {!readOnly && onRemove && (
              <button
                type="button"
                onClick={() => onRemove(tagId)}
                className="ml-1 hover:text-destructive"
              >
                <X className="h-3 w-3" />
              </button>
            )}
          </Badge>
        )
      })}
    </div>
  )
}

